// Module
var code = "<div class=\"error-503\"> <div class=\"error-503__text\"> <img class=\"error-503__img text-bold\" src=\"img/error/503.svg\" alt=\"down for maintenance\"/> </div> </div> ";
// Exports
module.exports = code;